import { Checkbox, styled, Typography } from '@mui/material';

export const ButtonsW = styled('div')`
  display: flex;
  gap: 8px;
`;

export const CheckboxW = styled('div')`
  display: flex;
  align-items: center;
`;

export const CheckboxInput = styled(Checkbox)`
  width: 20px;
  height: 20px;

  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.info.light};
  }
`;

export const LabelTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '24px',
  color: theme.palette.primary.p080,
  marginBottom: '16px',
  marginLeft: '10px',
  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
  },
}));

export const LabelW = styled('label')`
  margin-left: 10px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  white-space: nowrap;
  color: ${({ theme }) => theme.palette.primary.main};

  @media (max-width: 1023px) {
    font-size: 14px;
  }
`;

export const FormContainer = styled('div')`
  width: 671px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid #ddd;
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 36px 25px;
  margin-right: 36px;

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
    margin-right: 0px;
  }
`;
